import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
    ContainerInner,
    ContainerSection,
} from '@components/_global/GlobalStyle/Global.styled';
import { Unavailable } from '@components/_universal/Survey/Unavailable/Unavailable';
import { FeedbackLayout } from '@components/templates/FeedbackLayout/FeedbackLayout';

import { getPath } from '@services/RouteService/paths';

export const UnavailablePage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <FeedbackLayout
            iconProps={{
                icon: 'SvgUnavailable',
                size: 86,
            }}
        >
            <ContainerInner>
                <ContainerSection>
                    <Unavailable
                        buttonOnPress={() => navigate(getPath({ path: '/' }))}
                        buttonText={t('GO_TO_DASHBOARD')}
                        description={t('DISCLOSURE_UNAVAILABLE_DESCRIPTION')}
                        title={t('UNAVAILABLE_TITLE')}
                    />
                </ContainerSection>
            </ContainerInner>
        </FeedbackLayout>
    );
};
